module.exports = __webpack_public_path__ + "img/dd-logo-mistu-w.99306d03.png";